module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade prestadora")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional")]), _vm._v(" "), _c('select-profissional', {
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalSelecionado(profissionalSelecionado);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sub-Grupo")]), _vm._v(" "), _c('select-subgrupo', {
    on: {
      "setSubgrupoSelecionado": function (subgrupoSelecionado) {
        _vm.setSubgrupoSelecionado(subgrupoSelecionado);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "data_de"
    }
  }, [_vm._v("Período")]), _vm._v(" "), _c('data-filtro', {
    attrs: {
      "name": "periodo"
    },
    on: {
      "operadorSelecionado": function($event) {
        _vm.filtros.periodoOperador = $event
      },
      "dataSelecionada": function($event) {
        _vm.filtros.periodo = $event
      },
      "data2Selecionada": function($event) {
        _vm.filtros.periodo2 = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "box-footer text-right"
  }, [(_vm.pdf) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.getPDF(_vm.filtros.modelo)
      }
    }
  }, [_vm._v("Recarregar PDF "), _c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Pesquisar Agenda do Prestador",
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar")])]), _vm._v(" "), (_vm.pdf) ? _c('div', [_c('embed', {
    attrs: {
      "type": "application/pdf",
      "src": _vm.pdf,
      "width": "100%",
      "height": _vm.heigthPdf
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable) && !_vm.pdf) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Falta")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.situacao),
      expression: "ativos.situacao"
    }]
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.profissional),
      expression: "ativos.profissional"
    }]
  }, [_vm._v("Profissional")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.paciente),
      expression: "ativos.paciente"
    }]
  }, [_vm._v("Paciente")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.telefone),
      expression: "ativos.telefone"
    }]
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.procedimento),
      expression: "ativos.procedimento"
    }]
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.rg),
      expression: "ativos.rg"
    }]
  }, [_vm._v("RG")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.cartao_sus),
      expression: "ativos.cartao_sus"
    }]
  }, [_vm._v("Cartão SUS")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.data_nascimento),
      expression: "ativos.data_nascimento"
    }]
  }, [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.idade),
      expression: "ativos.idade"
    }]
  }, [_vm._v("Idade")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.sexo),
      expression: "ativos.sexo"
    }]
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.data_realizacao),
      expression: "ativos.data_realizacao"
    }]
  }, [_vm._v("Data do atendimento")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.tipo),
      expression: "ativos.tipo"
    }]
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.endereco),
      expression: "ativos.endereco"
    }]
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.municipio),
      expression: "ativos.municipio"
    }]
  }, [_vm._v("Município")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.unidade_solicitante),
      expression: "ativos.unidade_solicitante"
    }]
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.subgrupo),
      expression: "ativos.subgrupo"
    }]
  }, [_vm._v("Subgrupo")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "data-toggle": "tooltip",
        "title": "Lançar falta",
        "disabled": _vm.disabledBtnFalta(item)
      },
      on: {
        "click": function($event) {
          _vm.lancarFalta(item)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-times"
    })])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.situacao),
        expression: "ativos.situacao"
      }]
    }, [_vm._v(_vm._s(_vm._f("situacaoSolicitacao")(item.solicitacao.situacao)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.profissional),
        expression: "ativos.profissional"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL"))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.paciente),
        expression: "ativos.paciente"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.nome))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.telefone),
        expression: "ativos.telefone"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.telefone))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.procedimento),
        expression: "ativos.procedimento"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.rg),
        expression: "ativos.rg"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.rg))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.cartao_sus),
        expression: "ativos.cartao_sus"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.cartao_sus))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.data_nascimento),
        expression: "ativos.data_nascimento"
      }]
    }, [_vm._v(_vm._s(_vm._f("dataFormatada")(item.solicitacao.paciente.data_nascimento)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.idade),
        expression: "ativos.idade"
      }]
    }, [_vm._v(_vm._s(_vm._f("idade")(item.solicitacao.paciente.data_nascimento)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.sexo),
        expression: "ativos.sexo"
      }]
    }, [_vm._v(_vm._s(_vm._f("sexo")(item.solicitacao.paciente.sexo)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.data_realizacao),
        expression: "ativos.data_realizacao"
      }]
    }, [_vm._v(_vm._s(_vm._f("dataFormatada")(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento)) + " às " + _vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.hora_inicial : item.contrato_subgrupo_atendimento.hora_inicial))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.tipo),
        expression: "ativos.tipo"
      }]
    }, [_vm._v(_vm._s(_vm._f("tipoConsulta")(item.tipo_consulta)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.endereco),
        expression: "ativos.endereco"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.endereco) + ", nº" + _vm._s(item.solicitacao.paciente.numero_endereco) + ", " + _vm._s(item.solicitacao.paciente.bairro))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.municipio),
        expression: "ativos.municipio"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.cidade.nome))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.unidade_solicitante),
        expression: "ativos.unidade_solicitante"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.contrato.unidade.nome))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.subgrupo),
        expression: "ativos.subgrupo"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.procedimento.forma_organizacao.subgrupo.nome))])])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.dataTable.data && _vm.dataTable.data.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 text-left"
  }, [_c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.getPDF(1)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Modelo 1")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.getPDF(2)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Modelo 2")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.getPDF(3)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Modelo 3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-center"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.situacao),
      expression: "ativos.situacao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.situacao) ? _vm._i(_vm.ativos.situacao, null) > -1 : (_vm.ativos.situacao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.situacao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "situacao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "situacao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "situacao", $$c)
        }
      }
    }
  }), _vm._v("Situação ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.tipo),
      expression: "ativos.tipo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.tipo) ? _vm._i(_vm.ativos.tipo, null) > -1 : (_vm.ativos.tipo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.tipo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "tipo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "tipo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "tipo", $$c)
        }
      }
    }
  }), _vm._v("Tipo ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.data_realizacao),
      expression: "ativos.data_realizacao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.data_realizacao) ? _vm._i(_vm.ativos.data_realizacao, null) > -1 : (_vm.ativos.data_realizacao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.data_realizacao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "data_realizacao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "data_realizacao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "data_realizacao", $$c)
        }
      }
    }
  }), _vm._v("Data atendimento ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.paciente),
      expression: "ativos.paciente"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.paciente) ? _vm._i(_vm.ativos.paciente, null) > -1 : (_vm.ativos.paciente)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.paciente,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "paciente", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "paciente", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "paciente", $$c)
        }
      }
    }
  }), _vm._v("Paciente ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.rg),
      expression: "ativos.rg"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.rg) ? _vm._i(_vm.ativos.rg, null) > -1 : (_vm.ativos.rg)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.rg,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "rg", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "rg", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "rg", $$c)
        }
      }
    }
  }), _vm._v("RG ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.cartao_sus),
      expression: "ativos.cartao_sus"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.cartao_sus) ? _vm._i(_vm.ativos.cartao_sus, null) > -1 : (_vm.ativos.cartao_sus)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.cartao_sus,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "cartao_sus", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "cartao_sus", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "cartao_sus", $$c)
        }
      }
    }
  }), _vm._v("Cartão SUS ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.profissional),
      expression: "ativos.profissional"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.profissional) ? _vm._i(_vm.ativos.profissional, null) > -1 : (_vm.ativos.profissional)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.profissional,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "profissional", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "profissional", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "profissional", $$c)
        }
      }
    }
  }), _vm._v("Profissional ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.subgrupo),
      expression: "ativos.subgrupo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.subgrupo) ? _vm._i(_vm.ativos.subgrupo, null) > -1 : (_vm.ativos.subgrupo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.subgrupo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "subgrupo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "subgrupo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "subgrupo", $$c)
        }
      }
    }
  }), _vm._v("Subgrupo ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.data_nascimento),
      expression: "ativos.data_nascimento"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.data_nascimento) ? _vm._i(_vm.ativos.data_nascimento, null) > -1 : (_vm.ativos.data_nascimento)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.data_nascimento,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "data_nascimento", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "data_nascimento", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "data_nascimento", $$c)
        }
      }
    }
  }), _vm._v("Data de nascimento ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.idade),
      expression: "ativos.idade"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.idade) ? _vm._i(_vm.ativos.idade, null) > -1 : (_vm.ativos.idade)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.idade,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "idade", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "idade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "idade", $$c)
        }
      }
    }
  }), _vm._v("Idade ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.procedimento),
      expression: "ativos.procedimento"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.procedimento) ? _vm._i(_vm.ativos.procedimento, null) > -1 : (_vm.ativos.procedimento)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.procedimento,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "procedimento", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "procedimento", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "procedimento", $$c)
        }
      }
    }
  }), _vm._v("Procedimento ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.unidade_solicitante),
      expression: "ativos.unidade_solicitante"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.unidade_solicitante) ? _vm._i(_vm.ativos.unidade_solicitante, null) > -1 : (_vm.ativos.unidade_solicitante)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.unidade_solicitante,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "unidade_solicitante", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "unidade_solicitante", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "unidade_solicitante", $$c)
        }
      }
    }
  }), _vm._v("Unidade Solicitante ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.telefone),
      expression: "ativos.telefone"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.telefone) ? _vm._i(_vm.ativos.telefone, null) > -1 : (_vm.ativos.telefone)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.telefone,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "telefone", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "telefone", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "telefone", $$c)
        }
      }
    }
  }), _vm._v("Telefone ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.sexo),
      expression: "ativos.sexo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.sexo) ? _vm._i(_vm.ativos.sexo, null) > -1 : (_vm.ativos.sexo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.sexo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "sexo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "sexo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "sexo", $$c)
        }
      }
    }
  }), _vm._v("Sexo ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.endereco),
      expression: "ativos.endereco"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.endereco) ? _vm._i(_vm.ativos.endereco, null) > -1 : (_vm.ativos.endereco)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.endereco,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "endereco", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "endereco", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "endereco", $$c)
        }
      }
    }
  }), _vm._v("Endereço ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.municipio),
      expression: "ativos.municipio"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.municipio) ? _vm._i(_vm.ativos.municipio, null) > -1 : (_vm.ativos.municipio)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.municipio,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "municipio", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "municipio", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "municipio", $$c)
        }
      }
    }
  }), _vm._v("Município ")])])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Agenda do prestador")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ed5a586e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/relatorios/agenda_prestador/index.vue
// module id = 899
// module chunks = 0